// extracted by mini-css-extract-plugin
export default {"serviceLanding":"Landing_serviceLanding__PjTRB","content":"Landing_content__Oeh+J","contentWrpr":"Landing_contentWrpr__VNYiK"};